export default __webpack_public_path__ + "static/media/tastyhandpullednoodles.db74e342.jpeg";